import React, { Component } from 'react'
import PageWrapper from '../../helper/PageWrapper'
import camK1 from '../../img/k1.png'
import camK1_K2 from '../../img/k2_.png'
import camK2M from '../../img/k2m.png'
import camIp from '../../img/ip.png'
import camK2X from '../../img/k2x.png'
import plusIcon from '../../img/icons/plus.svg'
import i18n from '../../languages/i18n'
import AiswSpinner from '../helper/aiswSpinner/aiswSpinner'
import StaigeButton from '../../components/styles/Button'
import StaigeBadge from '../../components/styles/Badge'

import { CameraData } from '@soccerwatch/common'
import { CameraContainer } from '../../services/cameraContainer'
import { Link, RouteComponentProps } from 'react-router-dom'
import { withRouter } from 'react-router'
import { ContractContainer } from '../../services/contractContainer'
import { getCameraCalibrationStatus } from '../../api/backstaige_v2'
import { StichingStatus } from '../../types/StichingStatus'

import './CameraList.scss'

const camN6 = `${process.env.PUBLIC_URL}/img/N6-Titelbild.png`

type CameraListStateType = {
  cameras: CameraData[]
  loadingData: boolean
  calibrationStatuses: { [cameraId: string]: StichingStatus | null }
  cameraSearchQuery: string
}

type CameraListPropsType = RouteComponentProps & {
  loadingData: boolean
  cameraContainer: CameraContainer
  contractContainer: ContractContainer
}

class CameraList extends Component<CameraListPropsType, CameraListStateType> {
  // Constructor
  private calibrationInterval: number | null = null

  constructor(props: CameraListPropsType) {
    super(props)
    this.state = {
      cameras: [],
      loadingData: true,
      calibrationStatuses: {},
      cameraSearchQuery: ''
    }
  }

  componentDidMount(): void {
    const cameras = this.props.cameraContainer.getCameraListForCurrentContract()
    this.setState({
      cameras,
      loadingData: this.props.cameraContainer.state.loadingData
    })
    // Kalibrierungsstatus für alle Pluto-Kameras abrufen
    this.fetchAllCalibrationStatuses(cameras)
    // Polling alle 30 Sekunden
    this.calibrationInterval = window.setInterval(() => {
      this.fetchAllCalibrationStatuses(this.state.cameras)
    }, 30000)
  }

  componentWillUnmount(): void {
    if (this.calibrationInterval) {
      clearInterval(this.calibrationInterval)
    }
  }

  fetchAllCalibrationStatuses = async (cameras: CameraData[]) => {
    const camerasWithId = cameras.filter((cam) => cam.RowKey)
    const statusPromises = camerasWithId.map(async (cam) => {
      try {
        const res = await getCameraCalibrationStatus(cam.RowKey)
        return { cameraId: cam.RowKey, status: res.data }
      } catch (err) {
        // Kein Status = noch nicht kalibriert
        return { cameraId: cam.RowKey, status: null }
      }
    })
    const results = await Promise.all(statusPromises)
    const statusMap: { [cameraId: string]: StichingStatus | null } = {}
    results.forEach(({ cameraId, status }) => {
      statusMap[cameraId] = status
    })
    this.setState({ calibrationStatuses: statusMap })
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  componentDidUpdate(prevProps: CameraListPropsType) {
    if (
      this.props.cameraContainer.state.loadingData !== this.state.loadingData &&
      this.props.contractContainer.state.loadingData !== this.state.loadingData
    ) {
      this.setState({
        loadingData: this.props.cameraContainer.state.loadingData
      })
    }

    if (
      JSON.stringify(this.props.cameraContainer.getCameraListForCurrentContract()) !==
      JSON.stringify(this.state.cameras)
    ) {
      const newCameras = this.props.cameraContainer.getCameraListForCurrentContract()
      this.setState({
        cameras: newCameras
      })
      // Kalibrierungsstatus für neue Kameras abrufen
      this.fetchAllCalibrationStatuses(newCameras)
    }
  }

  renderSingleCamera = (camera: CameraData) => {
    const cam = camera
    const hardwarePlatform = (cam.hardwarePlatform ?? '').toLowerCase()
    let cameraImg
    if (hardwarePlatform.includes('n6')) {
      cameraImg = <img src={camN6} />
    } else {
      switch (hardwarePlatform) {
        case 'ip':
        case 'qube':
          cameraImg = <img src={camIp} />
          break
        case 'k1':
          cameraImg = <img src={camK1} style={{ height: '180px' }} />
          break
        case 'k2m':
          cameraImg = <img src={camK2M} />
          break
        case 'k2x':
          cameraImg = <img src={camK2X} />
          break
        default:
          cameraImg = <img src={camK1_K2} />
          break
      }
    }

    return (
      <Link to={`/cameramonitor/${cam.RowKey}`} className='content-cameraItem' key={cam.RowKey}>
        <div className='cameraItem-img2'></div>
        <div className='cameraItem-img'>
          <div className='saa'>
            <div className='bbb'>
              <svg
                width='327'
                height='102'
                viewBox='0 0 327 102'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <mask id='mask0_1608_1492' maskUnits='userSpaceOnUse' x='0' y='0' width='327' height='102'>
                  <rect y='0.517212' width='327' height='101.483' rx='3.75862' fill='#F6F6F6' />
                </mask>
                <g mask='url(#mask0_1608_1492)'>
                  <path
                    d='M65.7759 51.0201L22.2832 8.03448L9.39655 21.0912L39.8235 51.1394L9.69485 81.6049L22.7605 94.4828L65.7759 51.0201Z'
                    fill='#151315'
                  />
                  <path
                    d='M114.638 51.0201L71.1453 8.03448L58.2586 21.0912L88.6855 51.1394L58.5569 81.6049L71.6226 94.4828L114.638 51.0201Z'
                    fill='#151315'
                  />
                  <path
                    d='M163.5 51.0201L120.007 8.03448L107.121 21.0912L137.548 51.1394L107.419 81.6049L120.485 94.4828L163.5 51.0201Z'
                    fill='#151315'
                  />
                  <path
                    d='M261.224 51.0201L304.717 8.03448L317.603 21.0912L287.177 51.1394L317.305 81.6049L304.239 94.4828L261.224 51.0201Z'
                    fill='#151315'
                  />
                  <path
                    d='M212.362 51.0201L255.855 8.03448L268.741 21.0912L238.314 51.1394L268.443 81.6049L255.377 94.4828L212.362 51.0201Z'
                    fill='#151315'
                  />
                  <path
                    d='M163.5 51.0201L206.993 8.03448L219.879 21.0912L189.452 51.1394L219.581 81.6049L206.515 94.4828L163.5 51.0201Z'
                    fill='#151315'
                  />
                </g>
              </svg>
            </div>
          </div>

          <div className='xx'>{cameraImg}</div>
        </div>
        <div className='cameraItem-content'>
          <div className='content-id'>
            <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
              {cam.reachable ? (
                <StaigeBadge active title='online' color='aqua' />
              ) : (
                <StaigeBadge active title='offline' />
              )}
              {this.state.calibrationStatuses[cam.RowKey] !== undefined &&
                this.state.calibrationStatuses[cam.RowKey]?.stitchingStatus.status !== 'CALIBRATED' &&
                (this.state.calibrationStatuses[cam.RowKey] ? (
                  <StaigeBadge
                    active
                    title={
                      this.state.calibrationStatuses[cam.RowKey]!.stitchingStatus.status === 'CALIBRATED'
                        ? 'Kalibriert'
                        : this.state.calibrationStatuses[cam.RowKey]!.stitchingStatus.status === 'DEGRADED'
                        ? 'Kalibrierungsversatz'
                        : this.state.calibrationStatuses[cam.RowKey]!.stitchingStatus.status ===
                          'UNCALIBRATED'
                        ? 'Nicht kalibriert'
                        : this.state.calibrationStatuses[cam.RowKey]!.stitchingStatus.status
                    }
                    color={
                      this.state.calibrationStatuses[cam.RowKey]!.stitchingStatus.status === 'DEGRADED'
                        ? 'yellow'
                        : undefined
                    }
                  />
                ) : (
                  <StaigeBadge active title='Noch nicht kalibriert' color='red' />
                ))}
            </div>
            <div className='id-text'>ID {cam.RowKey}</div>
          </div>
          <div className='content-info'>
            <div className='info-version'>{cam.hardwarePlatform}</div>
            <div className='info-place'>{cam.address}</div>
          </div>
          <div className='content-field'>{}</div>
        </div>
        <div className='cameraItem-action'>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <mask id='mask0_693_13796' maskUnits='userSpaceOnUse' x='0' y='0' width='24' height='24'>
              <rect width='24' height='24' fill='#F6F6F6' />
            </mask>
            <g mask='url(#mask0_693_13796)'>
              <path d='M15 19L13.6 17.6L18.2 13H2V11H18.2L13.6 6.4L15 5L22 12L15 19Z' fill='#F6F6F6' />
            </g>
          </svg>
        </div>
      </Link>
    )
  }

  render() {
    if (this.state.loadingData) {
      return (
        <PageWrapper headerTitle={i18n.t('cameraList.headerTitle')}>
          <div style={{ width: '100%', height: '100%' }}>
            <AiswSpinner />
          </div>
        </PageWrapper>
      )
    }

    if (!this.state.loadingData && this.state.cameras.length === 0) {
      return (
        <PageWrapper headerTitle={i18n.t('cameraList.headerTitle')}>
          <div className='page-cameraList' style={{ height: '100%' }}>
            <div className='cameraList-noAllow'>
              <div className='noAllow-text'>
                {i18n.t('cameraList.noAllowText')}
                <br />
                {i18n.t('cameraList.noAllowText2')}
              </div>
              <StaigeButton
                label={i18n.t('cameraList.btnAddCam')}
                linkTo='/claim/camera'
                icon={plusIcon}
                iconMargin='0 0 0 -6px'
              />
            </div>
          </div>
        </PageWrapper>
      )
    }

    const searchQuery = (this.state.cameraSearchQuery || '').trim().toLowerCase()
    const filteredCameras =
      this.state.cameras.length > 2 && searchQuery
        ? this.state.cameras.filter(
            (cam) =>
              (cam.RowKey || '').toLowerCase().includes(searchQuery) ||
              (cam.address || '').toLowerCase().includes(searchQuery) ||
              (cam.hardwarePlatform || '').toLowerCase().includes(searchQuery)
          )
        : this.state.cameras

    return (
      <PageWrapper headerTitle={i18n.t('cameraList.headerTitle')}>
        <div className='page-cameraList'>
          <div className='cameraList-cameraList'>
            <div
              className={
                'cameraList-action' + (this.state.cameras.length > 2 ? ' cameraList-action--withSearch' : '')
              }
            >
              {this.state.cameras.length > 2 && (
                <input
                  type='search'
                  className='cameraList-search'
                  placeholder={i18n.t('cameraList.searchPlaceholder')}
                  value={this.state.cameraSearchQuery}
                  onChange={(e) => this.setState({ cameraSearchQuery: e.target.value })}
                  aria-label={i18n.t('cameraList.searchPlaceholder')}
                />
              )}
              <StaigeButton
                label={i18n.t('cameraList.btnAddCam')}
                icon={plusIcon}
                iconMargin='0 0 0 -4px'
                linkTo={'/claim/camera'}
                size='medium'
              />
            </div>
            <div className='cameraList-content'>
              {filteredCameras.map((cam: CameraData) => {
                return this.renderSingleCamera(cam)
              })}
            </div>
          </div>
        </div>
      </PageWrapper>
    )
  }
}

export default withRouter(CameraList)
